module.exports = __webpack_public_path__ + "static/img/64.5f04388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/64.jpg
// module id = hCT0
// module chunks = 0